import {CommonThemeColors, DEFAULT_COLOR_THEME} from "crqlar-react-common/dist/components/theme";
import {Stack, Typography} from "@mui/material";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import PersonIcon from "@mui/icons-material/Person";
import React from "react";

interface Props {
    statsTitle: string
    tableCount?: number
    guestCount?: number
    adultCount?: number
    teenagerCount?: number
    childCount?: number
    infantCount?: number
    fullWidth?: boolean
}

const RestaurantOccupancyStatsBlock = (props: Props) => {

    return(
        <Stack
            direction={'column'}
            gap={0.5}
            sx={{
                backgroundColor: CommonThemeColors.ref.primary.primary95,
                borderRadius: '4px',
                padding: props.fullWidth ? '8px 12px' : '4px 8px',
                width: props.fullWidth ? '100%' : '15em'
            }}
        >
            <Typography variant={'h6'}>
                {props.statsTitle}
            </Typography>

            <Typography
                variant={'body1'}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                }}
            >
                <TableRestaurantIcon
                    sx={{
                        fontSize: '1.2em',
                        pb: '0.1em'
                    }}
                />

                {props.tableCount}

            </Typography>

            <Typography
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                }}
            >
                <PersonIcon
                    sx={{
                        fontSize: '1.2em',
                        pb: '0.2em'
                    }}
                />

                {props.guestCount + ' (' + props.adultCount + '/' + props.teenagerCount + '/' + props.childCount + '/' + props.infantCount + ')'}

            </Typography>

        </Stack>
    )
}

export default RestaurantOccupancyStatsBlock
